import React from 'react'
import {
  FileDownload as ExportIcon,
  Calculate as CalculateIcon,
} from '@mui/icons-material'
import { Button } from '@mui/material'
import ActionButton from './ActionButton'
import { COLORS, containerStyles } from '../styles'

const TableToolbar = ({ editedRows, onSaveAll, onRestoreAll, onExportToExcel, onCalcular }) => {
  const editedCount = editedRows.size
  
  return (
    <div style={containerStyles.toolbar}>
      {editedCount > 0 && (
        <>
          <span style={containerStyles.editedCount}>
            {editedCount} NS editado{editedCount > 1 ? 's' : ''}
          </span>
          <ActionButton
            onClick={onSaveAll}
            backgroundColor={COLORS.buttonGreen}
            hoverColor={COLORS.buttonGreenHover}
            title="Guardar todos los NS editados"
            style={{ marginRight: '8px' }}
          >
            Guardar
          </ActionButton>
          <ActionButton
            onClick={onRestoreAll}
            backgroundColor={COLORS.buttonOrange}
            hoverColor={COLORS.buttonOrangeHover}
            title="Restaurar todos los valores originales"
            style={{ marginRight: '8px' }}
          >
            Restaurar todo
          </ActionButton>
        </>
      )}
    
      <Button
            variant="outlined"
            startIcon={<ExportIcon />}
            onClick={onExportToExcel}
            sx={{
              borderColor: '#4c75aa',
              color: '#4c75aa',
              '&:hover': {
                backgroundColor: '#e3f2fd',
                borderColor: '#4c75aa',
              },
            }}
          >
            Exportar
          </Button>
          <Button
            variant="outlined"
            startIcon={<CalculateIcon />}
            onClick={onCalcular}
            sx={{
              borderColor: '#4caa64',
              color: '#4caa64',
              '&:hover': {
                backgroundColor: '#e8f5e8',
                borderColor: '#4caa64',
              },
            }}
          >
            Calcular
          </Button>
   
    </div>
  )
}

export default TableToolbar 